module.exports = __webpack_public_path__ + "cd64c9cbdac4f9dfcb64ef0fc6fee832.svg";